import { defineComponent as _defineComponent } from 'vue'
import ProfileBlock from '@/features/user-profile/components/ProfileBlock.vue';
import TextRecommendationPreview from '@/features/why-to-watch/components/TextRecommendationPreview.vue';

import { useUserProfile } from '@/features/user-profile/composables/useUserProfile';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserTextRecommendationPreview',
  setup(__props) {

const { textRecommendations, textRecommendationCounts, setView } = useUserProfile();

return { __sfc: true,textRecommendations, textRecommendationCounts, setView, ProfileBlock, TextRecommendationPreview }
}

})